import React from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import "./index.css";

const DiscountPreferencesTable = () => {
  const { discountReferences, loading } = useSelector(
    (state) => state.discountReducer
  );

  const discountFilterBillAmount = discountReferences.filter(
    (discount) => discount.billAmount !== null
  );
  const percentOf = (x, y) => {
    if (x !== 0 && y !== 0) return (x / y) * 100;
    return 0;
  };

  const onlyUnique = (value, index, array) => {
    return array.indexOf(value) === index;
  };

  const columnFilter = (property) => {
    return discountFilterBillAmount
      .map((discount) => discount[property])
      .filter(onlyUnique)
      .map((name) => {
        return {
          text: name,
          value: name,
        };
      });
  };

  const percentFilter = () => {
    return discountFilterBillAmount
      ?.map((discount) =>
        percentOf(discount?.billDiscount, discount?.billAmount)
      )
      ?.filter(onlyUnique)
      ?.map((name) => {
        return {
          text: `${name.toFixed(0)}%`,
          value: name.toFixed(0),
        };
      })
      ?.sort((a, b) => a.value - b.value);
  };

  const columns = [
    {
      title: "Дата/Час",
      dataIndex: "created",
      key: "created",
      render: (text) => <p>{dayjs(text).format("DD/MM/YYYY HH:mm:ss")}</p>,
    },
    {
      title: "Сума",
      dataIndex: "billAmount",
      key: "billAmount",
      render: (text, record) => <p>{record?.billAmount?.toFixed(2)} €</p>,
    },
    {
      title: "% Отстъпка",
      key: "percent",
      render: (text, record) =>
        record.billAmount !== null &&
        record.billDiscount !== null && (
          <p>
            {percentOf(record?.billDiscount, record?.billAmount)?.toFixed(0)}%
          </p>
        ),
      filters: percentFilter(),
      filterSearch: true,
      onFilter: (value, record) =>
        percentOf(record?.billDiscount, record?.billAmount)?.toFixed(0) ===
        value,
    },
    {
      title: "Отстъпка",
      dataIndex: "billDiscount",
      key: "billDiscount",
      render: (text, record) => <p>{record?.billDiscount?.toFixed(2)} €</p>,
    },
    {
      title: "Платено",
      key: "pay",
      render: (text, record) => (
        <p>{(record.billAmount - record.billDiscount)?.toFixed(2)} €</p>
      ),
    },
    {
      title: "Потребител",
      dataIndex: "userFullName",
      key: "userFullName",
      filters: columnFilter("userFullName"),
      filterSearch: true,
      onFilter: (value, record) => record?.userFullName?.startsWith(value),
    },
    {
      title: "Ресторант",
      dataIndex: "restaurantName",
      key: "restaurantName",
      filters: columnFilter("restaurantName"),
      filterSearch: true,
      onFilter: (value, record) => record?.restaurantName?.startsWith(value),
    },
  ];

  return (
    <>
      <Table
        loading={loading}
        className="discounts-preferences-table"
        rowKey="id"
        key="discounts-preferences-table"
        dataSource={discountFilterBillAmount}
        columns={columns}
        pagination={{ pageSize: 100 }}
      />
    </>
  );
};

export default DiscountPreferencesTable;
